<template>
    <div class="partychildPage1">
        <div v-if="dataList.length!=0">
            <div class="datalistBox">
                <!-- <div class="leftImgRightTextBox">
                <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                    <div class="dateBox">
                        <div class="newsday">{{item.pressTime | day}}</div>
                        <div class="newsyearmonth">{{item.pressTime | timer}}</div>
                    </div>
                    <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                    <div class="contentbox">
                        <div class="title overflowone">{{item.pressTopic}}</div>
                        <div class="synopsis overflowthree">{{item.synopsis}}</div>
                    </div>
                </div>
            </div> -->
                <div class="leftImgRightTextBox">
                    <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                        <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                        <div class="contentbox">
                            <div class="title overflowone">{{item.pressTopic}}</div>
                            <div class="synopsis overflowtwo">{{item.synopsis}}</div>
                            <div class="time">{{item.pressTime | timer}}</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[8, 10, 12,16]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="emptyBox" v-else>
            <img src="@/assets/imgs/home/emptyimg.png" />
        </div>
    </div>

</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
    },
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: 10,
            pageSize: 8,
            dataList: []
        }
    },
    watch: {
        $route: {
            handler: function (val, oldVal) {
                let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
                if (currentNew) {
                    if (currentNew.currentPage) {
                        this.currentPage = currentNew.currentPage * 1;
                        // this.getNews();
                    }
                    if (currentNew.site) {
                        document.body.scrollTop = currentNew.site
                    }
                }
                sessionStorage.removeItem('currentNew')
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass: 24,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            let currentNew = {
                menuurl: '/party-secondpage/party-leads',
                currentPage: this.currentPage,
                site: window.scrollY,
                title: '党建引领'
            }
            sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.partychildPage1 {
	width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	// max-height: 1600px;
	min-height: 600px;
	position: relative;
	// position: relative;
	.pagination-box {
		// margin-bottom: 0;
		position: absolute;
		bottom: -40px;
		left: 50%;
		transform: translateX(-50%);
	}
	.datalistBox {
		// min-height: 400px;
		padding-bottom: 30px;
		.leftImgRightTextBox {
			.itemBox {
				margin: 0 0 40px 0;
				width: 100%;
				cursor: pointer;
				.imgbox {
					width: 280px;
					height: 152px;
				}
				.contentbox {
					width: 74%;
					.time {
						margin-top: 0;
					}
				}
			}
		}
	}
}
</style>


